export default __webpack_public_path__ + "static/media/ORYX_KinematicsIcon.3401c46f.svg";